import React from "react"
import FieldHeader from "components/requiredFields/FieldHeader"
import {
    existsValidation,
    displayValidFeedbackIcon,
    displayValidFeedbackMessage,
    genValidationFunction,
} from "shared/imports/validationFunctions"
import classNames from "classnames"
import PropTypes from "prop-types"

// these styles are only used by CampaignForm and ActionCenterSettingsForm
import "app/static/stylus/InputField.styl"

// switching entirely to the store
// only difference for this component is that it will be calling update onBlur
// and no longer has to support getInputValue
// it looks like we probably won't need refs anymore either

export default class InputField extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            validated: undefined,
            // 'hideValidatedIcon' is referred to in 'shared/imports/validationFunctions'
            // It is a little bit of an anti-pattern to initialize state with props
            // but should be okay in this case since 'hideValidatedIcon' won't change after component is mounted
            // And the validation function errors if we try to reference `this.props`
            hideValidatedIcon: props.hideValidatedIcon,
        }
        this.validate = genValidationFunction(this.props.validationFn || existsValidation).bind(this)
        this.displayValidFeedbackIcon = this.displayValidFeedbackIcon.bind(this)
        this.displayValidFeedbackMessage = this.displayValidFeedbackMessage.bind(this)
        this.onAnyChange = this.onAnyChange.bind(this)
    }

    onAnyChange(e) {
        const valueObj = { [this.props.dbName]: e.target.value }

        if (this.props.skipUpdates) {
            if (this.isValueChanged(e)) {
                this.props.updatingFn(valueObj, { [this.props.dbName]: this.validate(e) })
                this.setState({ value: e.target.value })
            }
        } else {
            this.props.updatingFn(valueObj, { [this.props.dbName]: this.validate(e) })
        }
    }

    isValueChanged(e) {
        return (
            (typeof this.props.initialValue !== "undefined" && e.target.value !== this.props.initialValue) ||
            (typeof this.props.initialValue === "undefined" && e.target.value !== "")
        )
    }

    renderInput() {
        return (
            <input
                data-cy={this.props.dataCy}
                key={this.props.placeholder + this.props.initialValue}
                ref={(node) => this.props.initializingFn(node, this.props.updatingFn, this.props.dbName)}
                defaultValue={this.props.initialValue || ""}
                className={classNames({
                    input: true,
                    "invalid-input":
                        !this.props.hideValidate && !this.state.validated && this.state.validated !== undefined,
                })}
                type="text"
                placeholder={this.props.placeholder || ""}
                onBlur={this.onAnyChange}
                disabled={this.props.disabled}
            />
        )
    }

    render() {
        return (
            <div className="input-field">
                <div className="field-header-holder">
                    <FieldHeader header={this.props.header} tooltip={this.props.tooltip} />
                </div>
                {this.renderInput()}
                {!this.props.hideValidate && this.displayValidFeedbackIcon()}
                {!this.props.hideValidate && this.displayValidFeedbackMessage(this.props.customValidationMessage)}
            </div>
        )
    }
}

InputField.prototype.displayValidFeedbackIcon = displayValidFeedbackIcon
InputField.prototype.displayValidFeedbackMessage = displayValidFeedbackMessage

InputField.propTypes = {
    validationFn: PropTypes.func,
    initializingFn: PropTypes.func,
    customValidationMessage: PropTypes.string,
    header: PropTypes.string,
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string,
    dbName: PropTypes.string,
    updatingFn: PropTypes.func,
    tooltip: PropTypes.string,
    hideValidatedIcon: PropTypes.bool,
    hideValidate: PropTypes.bool,
}

InputField.defaultProps = {
    initializingFn: () => null,
    updatingFn: () => null,
    hideValidatedIcon: false,
    customValidationMessage: "Sorry, this input is invalid.",
}
